<template>
  <div class="contract-details-display">
    <div class="row">
      <div class="col-sm-6">
        <vue-form :options="{
          permalink: 'generateContractReport',
          params: {
            ContractUuid: this.$route.params.contractId
          }
        }">
        </vue-form>
        <div class="card card-primary mt-2">
           <div class="card-header">
            Contract Details
          </div>
          <div class="card-body">
            <router-link class="btn-xs btn btn-warning mb-2" :to="'/contracts/terms/edit/' + contract.uuid">
              <span class="fa fa-edit fa-fw"></span> Edit
            </router-link>
            <accordian-display :icon="'fa-file-alt'" title="Contract Particulars" :default-open="true">
              <tr>
                <td class="font-weight-bold">Contract Type</td>
                <td>
                  {{ contractType }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Revenue to Client</td>
                <td>
                  {{ contract.contractSplit }}%
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Monthly Payments</td>
                <td>
                  <template v-for="car in contract.Cars">
                    <div :key="car.uuid" class="btn-margin">
                      <strong>{{ car.dropdownLabel }}</strong>
                      <br>
                      <strong>Current Payment</strong> {{ car.monthlyContractCost * currentFactor | to_dollar_amount }}
                      <br>
                      <strong>Per Annum Increase</strong> {{ contract.perAnnumIncrease }}%
                      <br>
                      <strong>Starting Payment</strong> {{ car.monthlyContractCost | to_dollar_amount }}
                    </div>
                  </template>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Public Fleet</td>
                <td>
                  {{ contract.publicFleet ? 'Yes' : 'No' }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Contract Period</td>
                <td>
                  {{ contract.contractStart | short_date_format_day }} - {{ contract.contractEnd | short_date_format_day }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Permitted KM</td>
                <td>
                  <template v-for="car in contract.Cars">
                    <div :key="car.uuid" class="btn-margin">
                      <strong>{{ car.dropdownLabel }}</strong>
                      <br>
                      {{ car.contractPermittedKm | pretty_number }} km
                    </div>
                  </template>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Additional KM Fee</td>
                <td>
                  {{ contract.additionalKmFee | to_dollar_amount }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Contract Inclusions</td>
                <td>
                  <ul>
                    <li v-for="(item, i) in contract.contractIncludes" :key="i">{{ item }}</li>
                    <li v-if="!contract.contractIncludes"><em>None</em></li>
                  </ul>
                </td>
              </tr>
            </accordian-display>
            <accordian-display :icon="'fa-user'" title="Point of Contact">
              <tr>
                <td class="font-weight-bold">Contact Person</td>
                <td>
                  {{ contract.contactPerson }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Phone</td>
                <td>
                  {{ contract.contactPhone }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Email</td>
                <td>
                  <a :href="`mailto:${contract.contactEmail}`">{{ contract.contactEmail }}</a>
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Company</td>
                <td>
                  {{ contract.Organization.companyName }}
                </td>
              </tr>
              <tr>
                <td class="font-weight-bold">Company Address</td>
                <td>
                  {{ contract.Organization.companyAddress }}<br/>
                  {{ contract.Organization.companySuburb }} {{ contract.Organization.companyPostcode }}<br/>
                  {{ contract.Organization.companyState }} {{ contract.Organization.companyCountry }}
                </td>
              </tr>
            </accordian-display>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card card-primary">
          <div class="card-header">
            Cars Under Contract
          </div>
          <div class="card-body">
            <template v-for="car in contract.Cars">
              <accordian-display :icon="'fa-car'" :title="car.dropdownLabel" :key="car.uuid">
                <contract-car-item
                  :object="car"
                  :usage="contract.kmUsage">
                </contract-car-item>
              </accordian-display>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContractCarItem from '@/components/displays/ContractCarItem'
import AccordianDisplay from '@/components/displays/AccordianDisplay'
import VueForm from '@/components/Form'
import { LOAD_CONTRACT_DETAILS } from '@/vuex/types'
import { mapGetters } from 'vuex'
import Util from '@server/util'

export default {
  name: 'ContractDetailsDisplay',
  components: {
    AccordianDisplay,
    ContractCarItem,
    VueForm
  },
  computed: {
    ...mapGetters([
      'contract'
    ]),
    contractType () {
      let matchCamels = new RegExp(/[A-Z\d]+(?![a-z])|[a-zA-Z][^A-Z\d\-_.\n]*/, 'g')
      function camelToTitle (match) {
        return `${match[0].toUpperCase()}${match.substr(1)} `
      }
      return this.contract.type.replace(matchCamels, camelToTitle)
    },
    currentFactor () {
      let contractYear = moment().diff(this.contract.contractStart, 'year')
      let currentFactor = 1
      if (contractYear > 0) {
        let percent = 1 + (this.contract.perAnnumIncrease / 100)
        currentFactor = Util.round(Math.pow(percent, contractYear))
      }
      return currentFactor
    }
  },
  mounted () {
    this.$store.dispatch(LOAD_CONTRACT_DETAILS, this.$route.params.contractId)
  },
  watch: {
    $route () {
      this.$store.dispatch(LOAD_CONTRACT_DETAILS, this.$route.params.contractId)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/ContractDetailsDisplay.vue